import React from 'react'
import { useObserver } from 'mobx-react'
import styled from 'styled-components'
import { Button, Alert, Spinner } from 'react-bootstrap'
import { ContentArea } from '../../components/Page/logix2020/ContentArea'
import { Subheader } from '../../components/Page/logix2020/Subheader'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import LocalReceiptsTable from '../../components/LocalReceipts/LocalReceiptsTable'
import { useLocalReceiptsState } from '../../stores/LocalReceiptsProvider'
import useStores from '../../stores/useStore'
import { useTranslation } from 'react-i18next'
import BigFooter from '../../components/Footer/BigFooter'
import { OverlayLeft } from '../../components/Page/logix2020/OverlayLeft'
import OverlayLeftFilter from '../../components/LocalReceipts/OverlayLeftFilter'
import ActiveTableFilters from '../../components/LocalReceipts/ActiveTableFilters'
import MediaQuery from 'react-responsive'
import { Link } from 'react-router-dom'
import { MdLibraryAdd } from 'react-icons/md'

const StyledContentArea = styled(ContentArea)`
  width: 100%;
  padding: 20px 30px 20px 36px;
  .control-row {
    display: felx;
    flex-wrap: wrap;
    align-items: baseline;
  }
  @media (max-width: 767px) {
    .mobileButton {
      width: 100%;
      margin-bottom: 10px;
    }
    padding: 20px;
    .control-row {
      display: block;
      flex-wrap: nowrap;
      align-items: stretch;
    }
  }
  .filterSpaceBetween {
    @media only screen and (min-width: 768px) {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
    }
  }
`

const GoodsReceiptPageContent = () => {
  const {
    handleLocalChangeCheckbox,
    setSelectedRow,
    setShowAllLocalReceipts,
    showOverlayLeft,
    setShowOverlayLeft,
    resetFilter,
    updateOverlayLeftStates,
  } = useLocalReceiptsState()
  const { t } = useTranslation()

  const onRowClick = (e, row) => {
    setSelectedRow((prev) => (prev === row ? false : row))
    handleLocalChangeCheckbox(row.id)
  }
  const handleCloseOverlayLeft = (e) => {
    setShowOverlayLeft(false)
    updateOverlayLeftStates()
  }
  return useObserver(() => (
    <div>
      <Subheader className='subHeader-v1'>
        <div className='subheader-title flex-grow-1'>
          {t('goodsReceiptPage:goodsReceipt')}
        </div>
        <MediaQuery minWidth={768}>
          <Link
            className='subheader__button btn btn-primary btn-extra-padding mobileButton'
            to='/localstorage/goodsreceipts/create'
          >
            <MdLibraryAdd className='me-3' />
            {t('goodsReceiptPage:createGoodsReceipt')}
          </Link>
        </MediaQuery>
      </Subheader>
      <OverlayLeft
        className={`overlay-variant ${showOverlayLeft ? 'visible' : ''}`}
      >
        <div className='header' onClick={handleCloseOverlayLeft}>
          <span onClick={handleCloseOverlayLeft}>
            <i className='close-icon' />
          </span>
          <span className='header-title'>{t('filter')}</span>
        </div>
        <div className='body'>
          <OverlayLeftFilter />
        </div>
      </OverlayLeft>
      <StyledContentArea>
        <div className='filterSpaceBetween'>
          <div className='control-row'>
            <MediaQuery maxWidth={767}>
              <Link
                className='btn btn-primary btn-extra-padding w-100 mobileButton'
                to='/localstorage/goodsreceipts/create'
              >
                {t('goodsReceiptPage:createGoodsReceipt')}
              </Link>
            </MediaQuery>
            <Button
              variant='secondary'
              className='mobileButton'
              onClick={() => {
                setShowOverlayLeft((prev) => !prev)
              }}
            >
              {t('allFilters')}
            </Button>
          </div>
          <div className='control-row'>
            <Button
              variant='secondary'
              className='btn-extra-padding mobileButton'
              onClick={() => {
                resetFilter()
                setShowAllLocalReceipts(true)
              }}
            >
              {t('goodsReceiptPage:showAllGoodsReceipts')}
            </Button>
          </div>
        </div>
        <ActiveTableFilters />
        <LocalReceiptsTable onRowClick={onRowClick} tableId='LocalReceipts' />
      </StyledContentArea>
      <BigFooter />
    </div>
  ))
}

const GoodsReceiptPage = () => {
  const { uiStore } = useStores()
  const { t } = useTranslation()
  const dashboardLoaded = useObserver(() => !!uiStore.dashboard)

  return useObserver(() => (
    <>
      {!uiStore.isLocalStorageAdmin ? (
        <>
          <Subheader className='subHeader-v1'>
            <div className='subheader-title'>
              {t('goodsReceiptPage:goodsReceipt')}
            </div>
          </Subheader>
          {dashboardLoaded ? (
            <Alert variant='danger'>{t('goodsReceiptPage:accessDenied')}</Alert>
          ) : (
            <div className='d-flex align-items-center justify-content-center'>
              <Spinner animation='border' variant='primary' />
            </div>
          )}
        </>
      ) : (
        <GoodsReceiptPageContent />
      )}
    </>
  ))
}
export default GoodsReceiptPage
